import { render, staticRenderFns } from "./AttachUser.vue?vue&type=template&id=d28aa79e&scoped=true&"
import script from "./AttachUser.vue?vue&type=script&lang=js&"
export * from "./AttachUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d28aa79e",
  null
  
)

export default component.exports